const Users = {
    NAME:'name',
    SURNAME:'surname',
    UID: 'uid',
    ROLE: 'role',

}

export default Users;